import { render, staticRenderFns } from "./EducationSection.vue?vue&type=template&id=84a9b5fc&scoped=true"
import script from "./EducationSection.vue?vue&type=script&lang=js"
export * from "./EducationSection.vue?vue&type=script&lang=js"
import style0 from "./EducationSection.vue?vue&type=style&index=0&id=84a9b5fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a9b5fc",
  null
  
)

export default component.exports